/** Text of stored HTML, for a label, the ledger or a "was …" caption ("Tour begins in the
 *  lobby"): tags dropped, a line break or a paragraph's end read as a space, the common
 *  entities decoded, whitespace collapsed. Pure — no editor or stylesheet is loaded. */
export function htmlText(html: unknown): string {
  if (typeof html !== 'string') return '';
  return html
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<\/(p|li)>/gi, ' ')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\s+/g, ' ')
    .trim();
}
